import langCN from './cn'
import langEN from './en'

const localLanguage = localStorage.getItem('jw-locale') || 'en-US'

export default localLanguage === 'zh-CN' ? langCN : langEN
